import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function Hero() {
  const navigate = useNavigate();

  const benefits = [
    'Livraison sous 48h',
    'Un seul interlocuteur',
    'Réponse garantie sous 24h',
  ];

  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden bg-gradient-to-br from-gold-50/30 via-transparent to-navy-50/20 pt-20">
      <div className="container mx-auto px-6 py-12 md:py-20 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            {/* Main Title */}
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-navy-600 leading-tight"
            >
              Visuels, Visites et contrôles légaux{' '}
              <span className="gradient-text">pour les études notariales</span>
            </motion.h1>

            {/* Subtitle */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-lg md:text-xl text-navy-400 leading-relaxed"
            >
              VISINOT est le partenaire des études notariales pour la mise en valeur, la gestion des visites et les contrôles légaux de leurs biens immobiliers.
            </motion.p>

            {/* Tagline */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.15 }}
              className="text-lg md:text-xl font-medium text-navy-600"
            >
              Gagnez du temps. Simplifiez votre quotidien. Déléguez l'opérationnel.
            </motion.p>

            {/* CTA */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="pt-2"
            >
              <Button
                variant="gold"
                size="xl"
                onClick={() => navigate('/commander')}
                className="group"
              >
                Commander
                <motion.div
                  animate={{ x: [0, 5, 0] }}
                  transition={{ duration: 1.5, repeat: Infinity }}
                >
                  <ArrowRight className="w-5 h-5" />
                </motion.div>
              </Button>
            </motion.div>

            {/* Benefits with green dots */}
            <motion.ul
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="flex flex-wrap justify-center gap-6"
            >
              {benefits.map((benefit, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.5 + index * 0.1 }}
                  className="flex items-center gap-2"
                >
                  <div className="w-2.5 h-2.5 rounded-full bg-green-500 flex-shrink-0" />
                  <span className="text-navy-600 font-medium">{benefit}</span>
                </motion.li>
              ))}
            </motion.ul>

            {/* Disclaimer */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="text-xs text-navy-300 max-w-xl mx-auto"
            >
              VISINOT est un prestataire de services. Nous ne sommes pas une agence immobilière et n'intervenons pas dans les négociations des biens.
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
